export enum ChangeLogStatuses {
  'import' = 'create',
  'update' = 'update',
  'reject' = 'reject',
  'published' = 'publish',
  'reported' = 'report',
  'edit' = 'edit',
}
